'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 21, viewBox: "0 0 20 21", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0002 18.1929C13.9768 18.1929 17.2005 14.9693 17.2005 10.9927C17.2005 7.01609 13.9768 3.79243 10.0002 3.79243C6.02366 3.79243 2.8 7.01609 2.8 10.9927C2.8 14.9693 6.02366 18.1929 10.0002 18.1929ZM10.0002 19.9929C14.9709 19.9929 19.0005 15.9634 19.0005 10.9927C19.0005 6.02198 14.9709 1.99243 10.0002 1.99243C5.02955 1.99243 1 6.02198 1 10.9927C1 15.9634 5.02955 19.9929 10.0002 19.9929ZM10.001 9.34302C10.5533 9.34302 11.001 9.79073 11.001 10.343V15.0138C11.001 15.5661 10.5533 16.0138 10.001 16.0138C9.44869 16.0138 9.00098 15.5661 9.00098 15.0138V10.343C9.00098 9.79073 9.44869 9.34302 10.001 9.34302ZM10.0001 8.61666C10.6641 8.61666 11.2024 8.07839 11.2024 7.41441C11.2024 6.75042 10.6641 6.21216 10.0001 6.21216C9.33612 6.21216 8.79785 6.75042 8.79785 7.41441C8.79785 8.07839 9.33612 8.61666 10.0001 8.61666Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg20;
//# sourceMappingURL=20.js.map
